export default {
  'header.product': '产品', 'header.customers': '客户', 'header.advertise': '广告投放', 'header.pricing': '价格',
  'header.signIn': '登录', 'header.startFree': '免费开始', 'header.toggleMenu': '切换菜单', 'header.language': '切换语言',
  'header.solutions': '解决方案', 'header.solutionsText': '按行业和角色划分的方案',
  'header.features': '功能', 'header.featuresText': '积分、奖励、会员等级等',
  'header.customersText': '借助会员忠诚度成长的团队',
  'header.security': '安全', 'header.securityText': '如何保护会员数据',
};
